/**
 * The remember surfaces' palette, matching `ContactDetail`'s `T` map and the
 * app's theme tokens so one person reads identically in both clients.
 *
 * Feather's `color` prop becomes the SVG `stroke` ATTRIBUTE, where `var()` is
 * invalid — anything handed to an icon needs a concrete value, which is why the
 * accent colours here are literals rather than custom properties.
 */
export const RT = {
  border: 'var(--glass-border, rgba(255,255,255,0.08))',
  borderStrong: 'rgba(255,255,255,0.15)',
  surface: 'rgba(255,255,255,0.04)',
  surfaceSoft: 'rgba(255,255,255,0.03)',
  muted: 'var(--text-muted, rgba(232,220,250,0.7))',
  dim: 'var(--text-dim, rgba(220,200,240,0.5))',
  dimSolid: 'rgba(220,200,240,0.5)',
  magenta: '#f0abfc',
  magenta2: '#d946ef',
  violetDeep: '#7c3aed',
  magentaTint: 'rgba(217,70,239,0.10)',
  magentaTintBorder: 'rgba(217,70,239,0.20)',
  gold: '#fcd34d',
  goldTint: 'rgba(251,191,36,0.07)',
  goldTintBorder: 'rgba(251,191,36,0.24)',
} as const;
